export class LanguageEn {

    vocabulary: {};

 constructor() {

    const vocabulary = {

      // ----------------------
      // COMIENZO VS-CUT
      // ----------------------

      ms1: 'Data entry',
      ms1_title: 'Home',
      ms1_subtitle: 'Section List',

      ms1_path_home: 'Home',

      // ----------------------
      // TITULOS VS-CUT (section "st_")
      // ----------------------

      st1_path: 'Files',
      st1_path_1: 'Edit',

      // Sección 1 => OPTIMIZADOR
      st1_title: 'File Module',
      st1_subtitle: 'Edition',
      st1_actionInfo: 'Do you want to save the file?',
      st1_actionOk: 'The action was successful.',

      st1_loadFile: 'Load File',
      st1_modalFile: 'Add from file',
      st1_modalFile_tt: 'Select file from your computer:',
      st1_modalFile_ph: 'Add from file',

      st1_modalFileButton: 'Load optimization from file',
      st1_modalFileButton_tt: 'Load optimization from file',

      st1_fieldName: 'Name',
      st1_fieldName_tt: 'File name',
      st1_fieldName_ph: 'File name',
      st1_fieldExist: 'Exist',
      st1_fieldExist_tt: 'Indicates if an optimized file already exists.',
      st1_fieldDescription: 'Description',
      st1_fieldDescription_tt: 'Description of the optimization file',
      st1_fieldDescription_ph: 'Enter a description for the optimization file.',

      // Sección 2 => 

      // ----------------------
      // FIN VS-CUT
      // ----------------------

      // ----------------------------------
      //  VS-CUT Menú Principal (mp)
      // ----------------------------------

      botonIniciarSesion: 'Log In',
      botonCerrarSesion: 'Log Out',
      selectIdiomaEs: 'Spanish',
      selectIdiomaEn: 'English',
      mpInicio: 'Home',
      mpMaestros: 'Master',
      mpOptimizador: 'Optimizer',
      mpInformes: 'Informs',
      mpImpresion: 'Print',
      mpIdioma: 'Language',

      // ----------------------
      // BOTONES
      // ----------------------
      buttonSearch: 'Search',
      buttonSearch_tt: 'Search elements',

      buttonNewElement: '+',
      buttonNewElement_tt: 'Add new element',

      buttonEdit: 'Edit',
      buttonEdit_tt: 'Edit item',

      buttonDelete: 'Delete',
      buttonDelete_tt: 'Delete item',

      buttonSave: 'Save',
      buttonSave_tt: 'Save modifications',

      buttonModify: 'Modify',
      buttonModify_tt: 'Modify item',

      buttonCancel: 'Cancel',
      buttonCancel_tt: 'Cancel action',

      buttonConfirm: 'Confirm',
      buttonConfirm_tt: 'Confirm action',

      // ----------------------
      // FILTROS
      // ----------------------
      filterText: 'Filter by ',
      filterSelectText: 'Select ',
      filterNoActiveText: 'Include non-active items',

    };

    this.vocabulary = vocabulary;

  } // End function constructor

} // End class LanguageEn